import { Navigate } from "react-router";
import { useAuth } from "@/lib/auth-context";

// Was: middleware.ts `if (pathname === "/")` → role-based redirect.
// Now: a tiny route element that consults the resolved session.
export function RoleRedirect() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;
  return (
    <Navigate
      to={session.role === "internal" ? "/admin/dashboard" : "/portal/dashboard"}
      replace
    />
  );
}
